module.exports = __webpack_public_path__ + "static/11-ad17680f9af4a5ef778c7e68d042e50f.png";